import api
from "../client";

/* =========================
   MEDIA LISTS
========================= */

export const listMediaLists =
  params =>
    api.get(
      "/media-lists",
      {
        params
      }
    );

export const getMediaList =
  id =>
    api.get(
      `/media-lists/${id}`
    );

export const createMediaList =
  payload =>
    api.post(
      "/media-lists",
      payload
    );

export const updateMediaList =
  (
    id,
    payload
  ) =>
    api.patch(
      `/media-lists/${id}`,
      payload
    );

export const deleteMediaList =
  id =>
    api.delete(
      `/media-lists/${id}`
    );

export const restoreMediaList =
  id =>
    api.patch(
      `/media-lists/${id}/restore`
    );

/* =========================
   PIN
========================= */

export const pinMediaList =
  id =>
    api.patch(
      `/media-lists/${id}/pin`
    );

export const unpinMediaList =
  id =>
    api.patch(
      `/media-lists/${id}/unpin`
    );

/* =========================
   FAVORITE
========================= */

export const favoriteMediaList =
  id =>
    api.patch(
      `/media-lists/${id}/favorite`
    );

export const unfavoriteMediaList =
  id =>
    api.patch(
      `/media-lists/${id}/unfavorite`
    );

/* =========================
   DUPLICATE
========================= */

export const duplicateMediaList =
  id =>
    api.post(
      `/media-lists/${id}/duplicate`
    );

/* =========================
   MEDIA
========================= */

export const getMediaListItems =
  (
    id,
    params
  ) =>
    api.get(
      `/media-lists/${id}/media`,
      {
        params
      }
    );

export const addMediaToList =
  (
    id,
    payload
  ) =>
    api.post(
      `/media-lists/${id}/media`,
      payload
    );

export const removeMediaFromList =
  (
    id,
    mediaId
  ) =>
    api.delete(
      `/media-lists/${id}/media/${mediaId}`
    );

/* =========================
   BULK
========================= */

export const bulkAddMediaToList =
  (
    id,
    payload
  ) =>
    api.post(
      `/media-lists/${id}/media/bulk-add`,
      payload
    );

export const bulkRemoveMediaFromList =
  (
    id,
    payload
  ) =>
    api.delete(
      `/media-lists/${id}/media/bulk-remove`,
      {
        data: payload
      }
    );

/* =========================
   MOVE
========================= */

export const moveMediaToList =
  (
    id,
    payload
  ) =>
    api.post(
      `/media-lists/${id}/media/move`,
      payload
    );

/* =========================
   COPY
========================= */

export const copyMediaToList =
  (
    id,
    payload
  ) =>
    api.post(
      `/media-lists/${id}/media/copy`,
      payload
    );